import { Component, OnInit, Input, ElementRef } from '@angular/core';

@Component({
    selector: 'qr-code',
    template: '<div></div>',
    standalone: false
})
export class QrCodeComponent implements OnInit {
  @Input() value: string;
  
  qr: any;

  constructor(private element: ElementRef) { }

  ngOnInit() {    
    let element = this.element.nativeElement.firstChild;
    let qc = (window as any).QRCode;
    this.qr = new qc(element, { 
      text: this.value,
      width: 130,
      height: 130
    });
  }
}
